import React from "react";
import { Search, Cpu, Rocket } from "lucide-react";

const STEPS = [
  { icon: Search, k: "01", label: "Friction Audit", sub: "48-hour discovery" },
  { icon: Cpu, k: "02", label: "48-Hour Prototype", sub: "your brand · your workflow" },
  { icon: Rocket, k: "03", label: "14-Day Deploy", sub: "engine live, team trained" },
];

const TrustBar = () => {
  return (
    <section data-testid="trust-bar" className="border-y border-white/10 bg-[#0F172A]">
      <div className="w-full mx-auto px-6 md:px-10 lg:px-16 xl:px-24 2xl:px-32 py-10 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-0">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <div
              key={s.k}
              data-testid={`trust-step-${s.k}`}
              className={`flex items-center gap-5 py-3 ${i > 0 ? "md:border-l md:border-white/10 md:pl-10" : ""}`}
            >
              <div className="shrink-0 w-12 h-12 border border-nex-gold/40 flex items-center justify-center bg-[#0B0F19] corner-tick">
                <Icon size={20} className="text-nex-gold" />
              </div>
              <div>
                <div className="flex items-center gap-3">
                  <span className="mono-body text-[10px] text-nex-muted">STEP.{s.k}</span>
                </div>
                <div className="serif-head text-lg text-nex-silver mt-0.5">{s.label}</div>
                <div className="mono-body text-[11px] mt-0.5">{s.sub}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default TrustBar;
